import { render, staticRenderFns } from "./CoozzyMobileAltIcon.vue?vue&type=template&id=dca26834&scoped=true"
import script from "./CoozzyMobileAltIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyMobileAltIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyMobileAltIcon.vue?vue&type=style&index=0&id=dca26834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca26834",
  null
  
)

export default component.exports